import React, { FC } from "react";
import { Descriptions, Anchor } from "antd";
import "./BscBridgeInfo.scss";

const VLAUNCH_BLOCK_EXPLORER = process.env.REACT_APP_BSC_BLOCK_EXPLORER;

interface Props {
  from: string;
  amount: number;
  txHash: string;
  timestamp?: number;
}

export const BscInfoTable: FC<Props> = ({ from, amount, txHash }) => {
  const { Link } = Anchor;
  return (
    <>
      <div className="table-size">
        <Descriptions
          column={{ xxl: 4, xl: 4, lg: 4, md: 4, sm: 4, xs: 4 }}
          bordered
        >
          <Descriptions.Item className="BSC-row-size" label="From">
            {from}
          </Descriptions.Item>
          <Descriptions.Item className="BSC-row-size" label="Amount">
            {amount}
          </Descriptions.Item>
          <Descriptions.Item className="BSC-row-size" label="Transaction Hash">
            <Anchor affix={false}>
              <Link
                href={`${VLAUNCH_BLOCK_EXPLORER}/tx/${txHash}`}
                title="Transaction Link"
                target="_blank"
              />
            </Anchor>
          </Descriptions.Item>
        </Descriptions>
      </div>
    </>
  );
};
